/**
 * Hub de "Reportar" — estático (solo enlaces). Se PRERENDERIZA para precachearlo
 * → accesible SIN conexión (el usuario puede llegar a los formularios offline).
 */
export const prerender = true;
